import Layout from '@/components/layout/Layout';
import { FC } from 'react';
import BookCardItem from '@/components/ui/book-card-item/BookCardItem';
import Pagination from '@/components/ui/pagination/Pagination';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import SectionTitle from '@/components/ui/section-title/SectionTitle';
import { BOOKS_FOR_PAGE } from '@/helpers/variables';
import { getAuthorFullName } from '@/helpers/helpers';
import { IReaderDetail } from '@/interfaces/readerDetail.interface';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';

interface IReaderDetailProps {
  reader: IReaderDetail;
}

const ReaderDetail: FC<IReaderDetailProps> = ({ reader }) => {
  const pagesCount = Math.ceil(reader.person_books_count / BOOKS_FOR_PAGE);
  const readerFullName = getAuthorFullName(reader.first_name, reader.middle_name, reader.last_name);
  const SEO_TITLE = `Чтец ${readerFullName} - слушать или скачать бесплатно все аудио книги - Fantasy Worlds`;
  const SEO_DESCRIPTION = `${readerFullName} озвучивает аудио книги. Все книги чтеца можно прослушать онлайн или скачать бесплатно в mp3 на сайте Fantasy Worlds.`;
  const SEO_CANONICAL = `/reader/${reader.alias}/`;

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} pageHref={useGetUrlPath()}>
      <Breadcrumbs firstPageName={`Чтец ${readerFullName}`} />
      <Pagination pagesCount={pagesCount ?? 0} postName={`reader/`} />
      <SectionTitle name={`Чтец книг ${readerFullName}`} />
      <div data-cards="list" className="cardsWrapper">
        {reader.books.length > 0 ? (
          reader.books.map((book, i) => (
            <BookCardItem
              key={`${book.id}-${i}`}
              createdAt={book.created_at}
              id={book.id}
              rating={book.rating}
              author={{ id: book.author_id, first_name: book.author_first_name, middle_name: book.author_middle_name, last_name: book.author_last_name }}
              // hideLitresData={false}
              // retelling={false}
              // draft={false}
              genres={book.genres}
              title={book.title}
              type={book.type}
              description={book.description}
              allow_full_free={0}
              external_id={book.external_id}
            />
          ))
        ) : (
          <div>Книги не найдены</div>
        )}
      </div>

      <Pagination pagesCount={pagesCount ?? 0} postName={`reader/`} />
    </Layout>
  );
};

export default ReaderDetail;
